<template>
    <b-navbar toggleable="lg" class="navbar-box border p-3">
        <b-row class="navbar-row">
            <b-col class="navbar-left" cols="10" sm="8" xl="9">
                <b-navbar-brand :to="'/'">
                    <b-img
                        src="/images/vietvardi.lu.lv.png"
                        class="logo"
                    ></b-img>
                </b-navbar-brand>

                <div class="auth-buttons" v-if="!authenticated">
                    <b-link @click="openLoginForm()" href="#">Ieiet</b-link>
                    |
                    <b-link @click="openRegistrationForm()" href="#"
                        >Reģistrēties</b-link
                    >
                </div>
                <div class="auth-buttons" v-if="authenticated">
                    <b-link v-if="authenticated" :to="'/lietotaja-konts'"
                        >{{ user.nickname }} <b-icon icon="person"></b-icon
                    ></b-link>
                </div>
            </b-col>
            <b-col class="navbar-right" cols="2" sm="4" xl="3">
                <div class="other-apps">
                    <b-img
                        src="/images/favicon-apvidvardi.png"
                        class="other-app"
                        @click="openOtherApp()"
                    ></b-img>
                </div>
                <b-dropdown
                    size="lg"
                    right
                    variant="text"
                    toggle-class="text-decoration-none"
                    class="menu-toggle"
                    no-caret
                >
                    <template #button-content>
                        <b-img
                            class="menu-icon"
                            src="/images/apvidvardi-sandwich.png"
                        ></b-img>
                    </template>
                    <b-dropdown-item :to="'/'">Sākums</b-dropdown-item>
                    <b-dropdown-item v-if="!authenticated">
                        <span @click="openLoginForm()">
                            Ieiet/Reģistrēties
                        </span>
                    </b-dropdown-item>
                    <b-dropdown-item :to="'/par-datubazi'">
                        Par datubāzi
                    </b-dropdown-item>
                    <b-dropdown-item :to="'/padomi-vaksana'">
                        Padomi vākšanā
                    </b-dropdown-item>
                    <b-dropdown-item :to="'/vietvardi'">
                        Visi vietvārdi
                    </b-dropdown-item>
                    <b-dropdown-item :to="'/vietvardu-karte'">
                        Vietvārdu karte
                    </b-dropdown-item>
                    <b-dropdown-item :to="'/instrukcija'">
                        Instrukcija
                    </b-dropdown-item>
                    <b-dropdown-item :to="'/privatuma-politika'">
                        Privātuma politika
                    </b-dropdown-item>
                    <b-dropdown-item :to="'/talkas-statistika'">
                        Talkas statistika
                    </b-dropdown-item>
                    <b-dropdown-item
                        :to="'/lietotaja-konts'"
                        v-if="authenticated"
                        href="#"
                    >
                        Lietotāja konts
                    </b-dropdown-item>
                    <b-dropdown-divider
                        v-if="authenticated"
                    ></b-dropdown-divider>
                    <b-dropdown-item
                        @click="logout()"
                        v-if="authenticated"
                        href="#"
                    >
                        Iziet
                    </b-dropdown-item>
                </b-dropdown>
            </b-col>
        </b-row>
        <login-form
            v-if="authFormVisible"
            :selectedForm="selectedForm"
            :showAuthRequiredMessage="showAuthRequiredMessage"
            @closeAuthModal="closeAuthModal"
        ></login-form>
        <create-new-toponym
            v-if="showCreateToponymForm"
            @closeCreateToponymModal="closeCreateModal"
            :id="selectedId"
            :newToponymCoords="newToponymCoords"
        ></create-new-toponym>
    </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import LoginForm from "./LoginForm.vue";
import CreateNewToponym from "./CreateNewToponym.vue";

export default {
    name: "appNavigation",
    components: {
        LoginForm,
        CreateNewToponym,
    },
    data: () => ({
        selectedForm: "login",
        authFormVisible: false,
        showCreateToponymForm: false,
        selectedId: null,
        showAuthRequiredMessage: false,
        newToponymCoords: {
            lat: null,
            lng: null,
        },
    }),
    computed: {
        ...mapGetters({
            authenticated: "auth/authenticated",
            user: "auth/user",
        }),
    },
    methods: {
        ...mapActions({
            signOut: "auth/signOut",
        }),
        openLoginForm() {
            this.selectedForm = "login";
            this.authFormVisible = true;
        },
        openRegistrationForm() {
            this.selectedForm = "register";
            this.authFormVisible = true;
        },
        closeAuthModal(data) {
            if (data && data.showMessage) {
                this.$bvToast.toast(data.body, {
                    title: data.title,
                    variant: data.variant,
                });
            }
            this.authFormVisible = false;
            this.showAuthRequiredMessage = false;
        },
        async logout() {
            await this.signOut().then(() => {
                this.$bvToast.toast("Lietotājs veiksmīgi izrakstijies", {
                    title: "Darbības apstiprinājums",
                    variant: "success",
                });
                this.$router.push({ name: "home" }).catch(() => {});
            });
        },
        openCreateToponymForm() {
            this.showCreateToponymForm = true;
        },
        closeCreateModal(data) {
            if (data && data.showMessage) {
                this.$bvToast.toast(data.body, {
                    title: data.title,
                    variant: data.variant,
                });
            }
            this.selectedId = null;
            this.showCreateToponymForm = false;
        },
        openOtherApp() {
            window.open("https://apvidvardi.lu.lv", "_blank");
        },
    },
    mounted() {
        this.$eventBus.$on("openRegistrationForm", () => {
            this.openRegistrationForm();
        });

        this.$eventBus.$on("openCreateOrUpdateToponymForm", (data) => {
            console.log("data", data);
            if (this.authenticated) {
                this.selectedId = data.id;
                if (data.coords) {
                    this.newToponymCoords.lat = data.coords.lat;
                    this.newToponymCoords.lng = data.coords.lng;
                }
                this.openCreateToponymForm();
            } else {
                this.showAuthRequiredMessage = true;
                this.openLoginForm();
            }
        });
    },
};
</script>

<style lang="scss" scoped>
@import "~@/_variables.scss";

.navbar-box {
    border-bottom: 1px solid #000 !important;
    // height: 82px;
}

.navbar-row {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
}

.navbar-left {
    justify-content: flex-start;
    align-items: center;
    display: flex;
}

.navbar-right {
    justify-content: space-between;
    align-items: center;
    display: flex;
}

.auth-buttons {
    padding-left: 48px;
    color: grey;

    a {
        color: grey;
        cursor: pointer;
        // text-decoration: underline;

        &:hover {
            color: #000 !important;
        }
    }
}

.logo {
    width: 200px;
}

.other-app {
    width: 32px;
    height: 32px;
    cursor: pointer;
}

.menu-icon {
    width: 24px;
    height: 24px;
    cursor: pointer;
}

.other-apps {
    display: block;
}

.auth-buttons {
    display: block;
}

@media (max-width: $xs-media) {
    .auth-buttons {
        display: none;
    }
    .navbar-left {
        justify-content: space-between;
    }

    .navbar-right {
        justify-content: flex-end;
    }

    .logo {
        width: 150px;
    }

    .other-app {
        width: 22px;
        height: 22px;
    }

    .menu-toggle {
        margin-right: -16px;
    }

    .other-apps {
        display: none;
    }
}
</style>
